import styled from 'styled-components';

export const AuthorWrapper = styled.div`
    margin: 10px 0;
`;

export const Author = styled.span`
    font-size: 1.6rem;
    color: var(--light-grey);

    a {
        margin-left: 2px;
        color: white;

        &:hover {
            color: var(--primary-on-hover);
        }
    }
`;